import React from 'react';
import { FieldAttributes, useField } from 'formik';

function Input(props: any) {
  const [field, meta] = useField(props);
  const showError = meta.touched && meta.error;

  if (props.type === 'textarea') {
    return (
      <textarea
        rows={5}
        maxLength={1000}
        {...(field as any)}
        className={`EditBox${showError ? ' ErrorInput' : ''} ${
          props.readOnly ? 'ViewOnly' : ''
        }`}
        {...props}
      ></textarea>
    );
  }
  return (
    <input
      {...(field as any)}
      className={`EditBox${showError ? ' ErrorInput' : ''} ${
        props.readOnly ? 'ViewOnly' : ''
      }`}
      disabled={props.disabled === true}
      value={props.value}
      {...props}
    />
  );
}

export { Input };
